import React, { useEffect, useState } from "react";
import Sidebar from "../../../../components/sections/admin/site-settings/components/Sidebar";
import PreviewPanel from "../../../../components/sections/admin/site-settings/components/PreviewPanel";
import SettingPannel from "../../../../components/sections/admin/site-settings/components/SettingPannel";
import { clickOnElemnt, rgba } from "../../../../helpers";
import { useDispatch } from "react-redux";
import { selectElement } from "../../../../redux/slice/themeSlice";
import { useSelector } from "react-redux";
import { classNames } from "../../../../helpers/classNames";

const SiteSettings = () => {
  const dispatch = useDispatch();
  const { theme, selectedElement, status } = useSelector(
    (state) => state?.themeProvider
  );

  useEffect(() => {
    const allEditableElements = document.querySelectorAll(
      ".editable-element:not(.not-changable)"
    );
    allEditableElements.forEach((el) => {
      el.style.border = "2px solid transparent";
    });

    const elm = document.getElementById(selectedElement);
    if (
      elm &&
      elm.classList.contains("editable-element") &&
      !elm.classList.contains("not-changable")
    ) {
      elm.style.border = "2px dashed #2563eb";
    }
  }, [selectedElement]);

  useEffect(() => {
    const handleMouseOver = (e) => {
      const target = e.target.closest(".editable-element");
      if (target && !target.classList.contains("not-changable")) {
        // dispatch(selectElement(target.id)); // if needed
        target.classList.add("hover-highlight");
      }
    };

    const handleMouseOut = (e) => {
      const target = e.target.closest(".editable-element");
      if (target && !target.classList.contains("not-changable")) {
        target.classList.remove("hover-highlight");
      }
    };

    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);

    return () => {
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", handleMouseOut);
    };
  }, [dispatch]);

  return (
    <div className="space-y-10">
      <div className="flex gap-6 h-[calc(100vh-190px)]">
        <div className="shadow-lg flex flex-grow max-w-[calc(100%-256px)] rounded-lg overflow-hidden site-setting">
          <div
            className={classNames(
              "w-64 editable-element",
              theme?.sidePanel?.backgroundColor ? "" : "bg-neutral-200"
            )}
            id="sidePanel"
            onClick={(e) => {
              dispatch(selectElement(clickOnElemnt({ event: e })));
            }}
            {...(theme?.sidePanel?.backgroundColor && {
              style: {
                backgroundColor: rgba(theme?.sidePanel?.backgroundColor),
              },
            })}
          >
            <Sidebar />
          </div>
          <div
            className="flex-grow max-w-[calc(100%-256px)] bg-white editable-element"
            id="previewPanel"
            onClick={(e) => {
              dispatch(selectElement(clickOnElemnt({ event: e })));
            }}
          >
            <PreviewPanel />
          </div>
        </div>
        <div className="w-64 max-h-fit shadow-lg p-2 rounded-lg scrollbar overflow-auto">
          <SettingPannel />
        </div>
      </div>
    </div>
  );
};

export default SiteSettings;
